module.exports = __webpack_public_path__ + "static/media/boa_transparent.74f44b5c.png";